(() => {
    const BUTTON_SELECTOR = "[js-like-btn]";
    const COUNT_SELECTOR = "[js-like-count]";
    const STORAGE_PREFIX = "otherhalf_like_once_v1:";

    const pending = new WeakSet();

    function storageKey(id, key) {
        return STORAGE_PREFIX + id + ":" + key;
    }

    function alreadyLiked(id, key) {
        try {
            return localStorage.getItem(storageKey(id, key)) === "1";
        } catch {
            return false;
        }
    }

    function markLiked(id, key) {
        try {
            localStorage.setItem(storageKey(id, key), "1");
        } catch {}
    }

    function getCount(btn) {
        return parseInt(btn.dataset.currentCount || "0", 10) || 0;
    }

    function setCount(btn, val) {
        btn.dataset.currentCount = val;

        const el = btn.querySelector(COUNT_SELECTOR);
        if (el) el.textContent = val;
    }

    async function handleClick(btn) {
        if (!btn || pending.has(btn)) return;

        const id = btn.dataset.objectId;
        const key = btn.dataset.fieldKey;

        if (!id || !key) return;
        if (alreadyLiked(id, key)) return;

        const current = getCount(btn);
        const next = current + 1;

        pending.add(btn);
        btn.setAttribute("aria-disabled", "true");

        setCount(btn, next);

        try {
            let API_URL;
            let body;

            if(btn.getAttribute("is") === "article") {
                API_URL = "https://otherhalf-likes-counter.vercel.app/api/v1/metafields/update";

                body = {
                    ownerId: id,
                    namespace: "custom",
                    key: key,
                    value: String(next)
                }
            }else {
                API_URL = "https://otherhalf-likes-counter.vercel.app/api/v1/likes/update";

                body = {
                    metaobjectId: id,
                    fieldKey: key,
                    value: String(next)
                }
            }
            
            const res = await fetch(API_URL, {
                method: "POST",
                mode: "cors",
                credentials: "omit",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body),
                keepalive: true
            });

            if (!res.ok) throw new Error();

            const json = await res.json();
            const serverVal = parseInt(json?.data?.value || next, 10);

            setCount(btn, serverVal);
            markLiked(id, key);

        } catch (e) {
            setCount(btn, current);
        } finally {
            pending.delete(btn);
            btn.removeAttribute("aria-disabled");
        }
    }

    document.addEventListener("click", (e) => {
        const btn = e.target.closest(BUTTON_SELECTOR);
        if (!btn) return;

        if (btn.getAttribute("aria-disabled") === "true") return;

        handleClick(btn);
    });
})();